export const LEGACY_ACCESS_TOKEN = '__legacy__';

export function isRealGatewayAccessToken(token: string | null | undefined): token is string {
  const value = String(token || '').trim();
  return Boolean(value) && value !== LEGACY_ACCESS_TOKEN;
}

export function gatewayAuthorizationHeaders(token: string | null | undefined): Record<string, string> {
  if (!isRealGatewayAccessToken(token)) {
    return {};
  }
  return { Authorization: `Bearer ${token}` };
}
